import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=723d6328"
import script from "./Counseling.vue?vue&type=script&lang=js"
export * from "./Counseling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports